import { fetchVaultConfig } from "../api/vault-config";
import type { VaultKey } from "./config";

const getVaultByKey = async (vaultKey: VaultKey) => {
  const vaultConfig = await fetchVaultConfig(vaultKey);

  if (!vaultConfig) {
    throw new Error(`Vault key ${vaultKey} not found`);
  }

  return vaultConfig;
};

export { getVaultByKey };
